// src/App.tsx
// Huvudapplikation för SireusCode med uppdaterade komponenter

// src/App.tsx
import React from 'react';
import { AppProvider } from './contexts/AppContext';
import Navigation from './components/Layout/Navigation';
import HeroSection from './components/Sections/HeroSection';
import ProcessSection from './components/Sections/ProcessSection';
import AboutSection from './components/Sections/AboutSection';
import ServicesSection from './components/Sections/ServicesSection';
import CaseStudiesSection from './components/Sections/CaseStudiesSection';
import ContactSection from './components/Sections/ContactSection';
import Footer from './components/Layout/Footer';
import NotificationContainer from './components/UI/NotificationContainer';

// src/App.tsx
const AppContent: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <NotificationContainer />
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <CaseStudiesSection /> 
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;